import { mockThreatsAPI } from './mockApi';
import ApiErrorHandler from './api-error-handler';
import { AxiosError } from 'axios';

// Instance du gestionnaire d'erreurs API
const errorHandler = ApiErrorHandler.getInstance();

// Exporter les API mock pour les menaces
export const threatsAPI = {
  getThreatSummary: async () => {
    try {
      console.log('Utilisation de l\'API mock pour getThreatSummary');
      const result = await mockThreatsAPI.getThreatSummary();
      errorHandler.recordApiSuccess('/api/threats/summary');
      return result;
    } catch (error) {
      console.error('Erreur lors de la récupération du résumé des menaces:', error);
      errorHandler.recordApiError(error as AxiosError);
      return { threats_count: 0, by_severity: [], by_status: [], recent_threats: [] };
    }
  },
  getThreats: async (params?: any) => {
    try {
      console.log('Utilisation de l\'API mock pour getThreats');
      const result = await mockThreatsAPI.getThreats(params);
      errorHandler.recordApiSuccess('/api/threats');
      return result;
    } catch (error) {
      console.error('Erreur lors de la récupération des menaces:', error);
      errorHandler.recordApiError(error as AxiosError);
      return { results: [], total: 0, page: 1, size: 10, pages: 0 };
    }
  },
  getThreat: async (id: string | number) => {
    try {
      console.log('Utilisation de l\'API mock pour getThreat');
      // Convertir l'id en chaîne pour assurer la compatibilité
      const result = await mockThreatsAPI.getThreat(String(id));
      errorHandler.recordApiSuccess(`/api/threats/${id}`);
      return result;
    } catch (error) {
      console.error(`Erreur lors de la récupération de la menace ${id}:`, error);
      errorHandler.recordApiError(error as AxiosError);
      return null;
    }
  },
  createThreat: async (data: any) => {
    try {
      console.log('Utilisation de l\'API mock pour createThreat');
      const result = await mockThreatsAPI.createThreat(data);
      errorHandler.recordApiSuccess('/api/threats');
      return result;
    } catch (error) {
      console.error('Erreur lors de la création de la menace:', error);
      errorHandler.recordApiError(error as AxiosError);
      return null;
    }
  },
  updateThreat: async (id: string | number, data: any) => {
    try {
      console.log('Utilisation de l\'API mock pour updateThreat');
      // Convertir l'id en chaîne pour assurer la compatibilité
      const result = await mockThreatsAPI.updateThreat(String(id), data);
      errorHandler.recordApiSuccess(`/api/threats/${id}`);
      return result;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour de la menace ${id}:`, error);
      errorHandler.recordApiError(error as AxiosError);
      return null;
    }
  },
  deleteThreat: async (id: string | number) => {
    try {
      console.log('Utilisation de l\'API mock pour deleteThreat');
      // Convertir l'id en chaîne pour assurer la compatibilité
      const result = await mockThreatsAPI.deleteThreat(String(id));
      errorHandler.recordApiSuccess(`/api/threats/${id}`);
      return result;
    } catch (error) {
      console.error(`Erreur lors de la suppression de la menace ${id}:`, error);
      errorHandler.recordApiError(error as AxiosError);
      return false;
    }
  }
};
